<template>
    <div class="axios chartConfig_viewDP">
        <!--X轴-->
        <div class="chartDivConfig checkViewConfig">
            <el-checkbox v-model="config.axios.xAxios.show" @change="getRender">是否展示{{AxisType}}轴</el-checkbox>
        </div>
        <div class="chartDivConfig checkViewConfig">
            <el-checkbox v-model="config.axios.xAxios.splitLine.show" @change="getRender">是否显示分隔线</el-checkbox>
        </div>
        <div class="chartDivConfig colViewConfig">
            <span class="span_til">分隔线颜色</span>
            <el-color-picker v-model="config.axios.xAxios.splitLine.lineStyle.color[0]" show-alpha @change="getRender"></el-color-picker>
        </div>
        <div class="chartDivConfig numViewConfig numViewConfig_unit">
            <span class="span_til">分隔线宽度</span>
            <el-input v-model="config.axios.xAxios.splitLine.lineStyle.width" @change="getRender" type="number" min="0"></el-input>
            <div class="unit">px</div>
        </div>
        <div class="chartDivConfig selViewConfig">
            <span class="span_til">分隔线类型</span>
            <el-select v-model="config.axios.xAxios.splitLine.lineStyle.type" placeholder="请选择分隔线类型"
                       :popper-append-to-body="false" @change="getRender">
                <el-option
                        v-for="item in lineList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                </el-option>
            </el-select>
        </div>
        <div class="chartDivConfig checkViewConfig">
            <el-checkbox v-model="config.axios.xAxios.boundaryGap" @change="getRender">{{AxisType}}轴是否从0开始</el-checkbox>
        </div>
        <div class="chartDivConfig numViewConfig numViewConfig_unit" v-show="config.axios.xAxios.show">
            <span class="span_til">轴线线宽</span>
            <el-input v-model="config.axios.xAxios.axisLine.lineStyle.width" @change="getRender" type="number" min="0"></el-input>
            <div class="unit">px</div>
        </div>
        <div class="chartDivConfig colViewConfig">
            <span class="span_til">轴线颜色</span>
            <el-color-picker v-model="config.axios.xAxios.axisLine.lineStyle.color" show-alpha @change="getRender"></el-color-picker>
        </div>
        <div class="chartDivConfig checkViewConfig">
            <el-checkbox v-model="config.axios.xAxios.axisTick.show" @change="getRender">是否显示坐标轴刻度</el-checkbox>
        </div>
        <div class="chartDivConfig checkViewConfig">
            <el-checkbox v-model="config.axios.xAxios.axisTick.inside" @change="getRender">坐标轴刻度是否朝内</el-checkbox>
        </div>
        <div class="chartDivConfig checkViewConfig">
            <el-checkbox v-model="config.axios.xAxios.axisLabel.show" @change="getRender">是否显示坐标轴文字</el-checkbox>
        </div>
        <div class="chartDivConfig numViewConfig numViewConfig_unit">
            <span class="span_til">字体大小</span>
            <el-input v-model="config.axios.xAxios.axisLabel.fontSize" @change="getRender" type="number" min="12"></el-input>
            <div class="unit">px</div>
        </div>
        <div class="chartDivConfig colViewConfig">
            <span class="span_til">字体颜色</span>
            <el-color-picker v-model="config.axios.xAxios.axisLabel.color" show-alpha @change="getRender"></el-color-picker>
        </div>
        <div class="chartDivConfig numViewConfig numViewConfig_unit"
            >
            <span class="span_til">字体角度</span>
            <el-input v-model="config.axios.xAxios.axisLabel.rotate" @change="getRender" type="number" min="0"></el-input>
            <div class="unit">度</div>
        </div>
    </div>
</template>

<script>
    /**
     @author xiaoye
     @date 2020/4/27 5:58 下午
     */
    export default {
        name: 'axios',
        components: {},
        props: {
            name: {
                type: String,
                default: ''
            },
            type: {
                type: String,
                default: ''
            },
        },
        data() {
            return {
                AxisType:'X',
                typeList:[
                    {value: 'category', label: '类目轴'},
                    {value: 'value', label: '数值轴'},
                ],
                lineList:[
                    {value: 'solid', label: '实线'},
                    {value: 'dashed', label: '虚线'},
                    {value: 'dotted', label: '点线'},
                ]
            }
        },
        computed: {
            config() {
                if (this.type === 'view') {
                    return this.$store.state.viewDP.chart.setting.params;
                } else if (this.type === 'screen') {
                    return this.$store.state.designer.chart.setting.params;
                }
            },
            nowChart() {
                if (this.type === 'view') {
                    return this.$store.state.viewDP.nowChart;
                } else if (this.type === 'screen') {
                    return this.$store.state.designer.chart;
                }
            }
        },
        methods: {
            getRender() {
                if (this.type === 'view') {
                    this.$store.dispatch('viewDPRender');
                } else if (this.type === 'screen') {
                    this.$store.dispatch('screenRender');
                }
            },
            getType() {
                if(this.nowChart.name==='条形图'){
                    this.AxisType = 'Y';
                }else{
                    this.AxisType = 'X';
                }
            }
        },
        mounted() {
            this.getType();
        },
        destroyed() {

        }
    }
</script>

<style lang="less">
    .axios {
        .chartDivConfig {
            .span_til {
                width: 26%!important;
                max-width: 74px !important;
            }
        }
    }
</style>